var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#CF812D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3522 31.84C19.7682 31.84 20.1682 31.728 20.5362 31.52L29.0162 26.624V30.864C29.0162 31.472 29.5122 31.968 30.1202 31.968C30.7282 31.968 31.2242 31.472 31.2242 30.864V17.104C31.2242 16.496 30.7282 16 30.1202 16C29.5122 16 29.0162 16.496 29.0162 17.104V21.344L20.5362 16.448C20.1842 16.24 19.7682 16.128 19.3522 16.128C18.0562 16.128 17.0002 17.184 17.0002 18.48V29.488C16.9842 30.784 18.0562 31.84 19.3522 31.84ZM19.2082 18.48C19.2082 18.368 19.3202 18.336 19.3522 18.336C19.3682 18.336 19.3842 18.336 19.4162 18.352L28.9362 23.856C28.9522 23.872 29.0002 23.904 29.0002 23.984C29.0002 24.064 28.9522 24.096 28.9362 24.112L19.4162 29.6C19.3842 29.616 19.3682 29.616 19.3522 29.616C19.3202 29.616 19.2082 29.584 19.2082 29.472V18.48Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkips);
export default __webpack_public_path__ + "static/media/skips.945d8b69da847108f48f0a904a9675c7.svg";
export { ForwardRef as ReactComponent };